import { useQuery } from '@apollo/client';
import {
  PermissionListFilterInput,
  PermissionsDocument,
  PermissionsQuery,
} from 'src/graphql/generated/graphql';

interface UsePermissionsProps {
  filter?: PermissionListFilterInput;
  pagination: {
    limit: number;
    page: number;
    extraRows?: number;
  };
  onCompleted?: (data: PermissionsQuery) => void;
}

export const usePermissions = ({
  filter,
  pagination,
  onCompleted,
}: UsePermissionsProps) => {
  const { limit = 100, page = 0, extraRows = 0 } = pagination || {};
  const offset = page * limit;

  const { data, loading } = useQuery<PermissionsQuery>(PermissionsDocument, {
    variables: {
      filter,
      pagination: {
        limit: limit + extraRows,
        offset,
      },
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
    onCompleted: onCompleted,
  });

  return {
    loading,
    data: data?.permissions.records || [],
    totalCount: data?.permissions.pagination.totalCount || 0,
  };
};
